import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "provider-shell" }
const _hoisted_2 = { class: "provider-header" }
const _hoisted_3 = { class: "provider-header-main" }
const _hoisted_4 = { class: "provider-avatar" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "provider-title-wrap" }
const _hoisted_8 = { class: "provider-title" }
const _hoisted_9 = { class: "provider-status-wrap" }
const _hoisted_10 = { class: "provider-stats" }
const _hoisted_11 = { class: "provider-stat" }
const _hoisted_12 = { class: "provider-stat-v" }
const _hoisted_13 = { class: "provider-stat" }
const _hoisted_14 = { class: "provider-stat-v" }
const _hoisted_15 = { class: "provider-stat" }
const _hoisted_16 = { class: "provider-stat-v provider-stat-v-label" }
const _hoisted_17 = { class: "provider-stat provider-stat-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "provider-brand-card",
    color: "background",
    variant: "elevated",
    elevation: "4",
    onClick: _ctx.emitEdit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "provider-rail",
        style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
      }, null, 4),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.showStandaloneIcon && _ctx.iconMode !== 'mono')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: (_ctx.icon as ProviderIcon).src,
                    alt: `${_ctx.displayLabel} icon`,
                    class: "provider-avatar-image",
                    onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                  }, null, 40, _hoisted_5))
                : (_ctx.showStandaloneIcon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "provider-avatar-mask",
                      style: _normalizeStyle(_ctx.iconMaskStyle),
                      role: "img",
                      "aria-label": `${_ctx.displayLabel} icon`
                    }, null, 12, _hoisted_6))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: "provider-initials",
                      style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
                    }, _toDisplayString(_ctx.providerInitials), 5))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.displayLabel), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_chip, {
              size: "small",
              color: "warning",
              variant: "tonal",
              class: "provider-status-chip"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-check-circle",
                  size: "x-small",
                  start: ""
                }),
                _cache[1] || (_cache[1] = _createTextVNode(" Connected "))
              ]),
              _: 1,
              __: [1]
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "provider-stat-k" }, "Models", -1)),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.llmModels.length), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "provider-stat-k" }, "Voices", -1)),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.voiceModels.length), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "provider-stat-k" }, "Provider", -1)),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.providerTypeLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_tooltip, {
              text: "Edit Provider",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "primary",
                  icon: "mdi-pencil-outline",
                  size: "small",
                  variant: "plain",
                  class: "provider-edit-icon",
                  onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                }), null, 16, ["onClick"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}